import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { Box, List, Typography, ListItem, ListItemText, } from '@mui/material';
import { useNavigate } from 'react-router';
import { useStore } from '@mcn-platform/models';
import PlaceHolder from '../../portal/common/PlaceHolder';
import linkNavigator from '../../portal/common/linkNavigator';
const Title = ({ text }) => (_jsx(Typography, { className: "footerHeading", children: text }));
const ListItemLink = (props) => {
    const { primary, src, imageStyle, editData, } = props;
    const store = useStore();
    const [linkData, setLinkData] = useState(primary);
    useEffect(() => {
        const loadLinkData = async () => {
            if (['course', 'microcast', 'document', 'program'].includes(primary.type)) {
                const data = await store.load(primary.type, primary[primary.type]);
                if (data) {
                    setLinkData({ ...primary, [primary.type]: data.slug || primary[primary.type] });
                }
            }
            if (primary.type === 'category') {
                const data = await store.getOrLoad(primary.type, primary[primary.type]);
                if (data) {
                    setLinkData({ ...primary, [primary.type]: data.slug || primary[primary.type] });
                }
            }
        };
        if (!primary.slug) {
            loadLinkData();
        }
    }, [primary, store]);
    // const renderLink = React.useMemo(
    //   () => React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>((
    //     itemProps,
    //     ref,
    //   // eslint-disable-next-line react/jsx-props-no-spreading
    //   ) => <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />),
    //   [to],
    // );
    const navigate = useNavigate();
    // console.log('primary', primary);
    return (_jsx(Box, { style: { marginTop: '6px', marginBottom: '6px' }, children: _jsxs(ListItem, { disablePadding: true, className: "footerListItem", onClick: (ev) => {
                linkNavigator(linkData, editData ? (link) => editData.preNavigationHook(link, ev) : navigate);
            }, sx: {
                cursor: 'pointer',
            }, children: [linkData && (_jsx(ListItemText, { disableTypography: true, sx: { m: 0 }, primary: (_jsx(Typography, { className: "footerListItemText", children: linkData.label })) })), src && _jsx("img", { src: src, style: { ...imageStyle, marginLeft: '-14px' }, alt: "alt" })] }) }));
};
ListItemLink.defaultProps = {
    src: undefined,
    imageStyle: undefined,
    primary: undefined,
};
const LinksWidget = ({ link, editData, limitToPageWidth, }) => {
    useEffect(() => { }, [link]);
    const isEmpty = () => {
        let isLinksEmpty = true;
        for (let i = 0; i < link.links.length; i += 1) {
            if (link.links[i].type !== '' || link.links[i].label) {
                isLinksEmpty = false;
            }
        }
        return link.title === '' && isLinksEmpty && editData;
    };
    if (isEmpty()) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Links Widget" }));
    }
    return (_jsx(Box, { sx: {
            width: '100%',
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
                backgroundColor: (t) => (t.portal.footer.background.color),
            }),
        }, children: _jsxs(Box, { sx: { width: '100%', mt: { lg: 0 } }, children: [link && _jsx(Title, { text: link.title }), _jsx(List, { disablePadding: true, sx: {
                        width: '100%', pl: 0.25,
                    }, children: link && link.links && link.links.map((subItem) => (_jsx(React.Fragment, { children: _jsx(ListItemLink, { primary: subItem, editData: editData }) }, subItem.id))) })] }) }));
};
LinksWidget.meta = {
    group: 'design',
    name: 'Links',
    sort: 60,
    description: 'Display a list of links.',
    props: [
        {
            key: 'link',
            name: 'Links',
            type: 'linkList',
            description: 'Footer links.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit To Max Page Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'LinksWidget',
        props: {
            limitToPageWidth: true,
            link: {
                title: '',
                links: [
                    {
                        id: v4(),
                        type: '',
                    },
                ],
            },
        },
    },
};
export default LinksWidget;
//# sourceMappingURL=LinksWidget.js.map